import { render, staticRenderFns } from "./download-items.vue?vue&type=template&id=3c23df1c&scoped=true&"
import script from "./download-items.vue?vue&type=script&lang=js&"
export * from "./download-items.vue?vue&type=script&lang=js&"
import style0 from "./download-items.vue?vue&type=style&index=0&id=3c23df1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23df1c",
  null
  
)

export default component.exports